// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome_welcome__M6FAu","header":"Welcome_header__86BDp","headerIcon":"Welcome_headerIcon__Pp8qC","headerText":"Welcome_headerText__mle+q","text":"Welcome_text__Sv20E"};